/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Manage_PermissionsInputs */

const en_knp_guide_manage_permissions = /** @type {(inputs: Knp_Guide_Manage_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Permissions`)
};

const fr_knp_guide_manage_permissions = /** @type {(inputs: Knp_Guide_Manage_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer les autorisations`)
};

const de_knp_guide_manage_permissions = /** @type {(inputs: Knp_Guide_Manage_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigungen verwalten`)
};

const it_knp_guide_manage_permissions = /** @type {(inputs: Knp_Guide_Manage_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci permessi`)
};

const ru_knp_guide_manage_permissions = /** @type {(inputs: Knp_Guide_Manage_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление правами доступа`)
};

const es_knp_guide_manage_permissions = /** @type {(inputs: Knp_Guide_Manage_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar permisos`)
};

const zh_cn2_knp_guide_manage_permissions = /** @type {(inputs: Knp_Guide_Manage_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理权限`)
};

const ja_knp_guide_manage_permissions = /** @type {(inputs: Knp_Guide_Manage_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`権限の管理`)
};

const hi_knp_guide_manage_permissions = /** @type {(inputs: Knp_Guide_Manage_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुमतियाँ प्रबंधित करें`)
};

const pt_pt2_knp_guide_manage_permissions = /** @type {(inputs: Knp_Guide_Manage_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciar permissões`)
};

/**
* | output |
* | --- |
* | "Manage Permissions" |
*
* @param {Knp_Guide_Manage_PermissionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_manage_permissions = /** @type {((inputs?: Knp_Guide_Manage_PermissionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Manage_PermissionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_manage_permissions(inputs)
	if (locale === "de") return de_knp_guide_manage_permissions(inputs)
	if (locale === "it") return it_knp_guide_manage_permissions(inputs)
	if (locale === "ru") return ru_knp_guide_manage_permissions(inputs)
	if (locale === "es") return es_knp_guide_manage_permissions(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_manage_permissions(inputs)
	if (locale === "ja") return ja_knp_guide_manage_permissions(inputs)
	if (locale === "hi") return hi_knp_guide_manage_permissions(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_manage_permissions(inputs)
	return en_knp_guide_manage_permissions(inputs)
});